import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import BrilloLogo from "@/components/BrilloLogo";
import { Loader2, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    try {
      await api.get("/auth/me");
      navigate("/admin", { replace: true });
    } catch {
      setChecking(false);
    }
  }, [navigate]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="h-6 w-6 animate-spin text-[#04b0ba]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f9fa] p-6">
      <div className="w-full max-w-md bg-white border border-[#e5e7eb] rounded-2xl p-8 shadow-sm" data-testid="admin-login-card">
        <BrilloLogo className="h-12 w-auto mx-auto" />
        <div className="mt-6 text-center">
          <div className="bf-chip mx-auto"><ShieldCheck className="h-3.5 w-3.5" /> Acceso restringido</div>
          <h1 className="mt-4 font-display text-2xl text-[#333333]">Panel administrador</h1>
          <p className="mt-2 text-sm text-[#666666]">
            Solo administradores autorizados de Brillo Finance pueden acceder.
          </p>
        </div>

        <button
          onClick={login}
          data-testid="admin-google-login-button"
          className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full border border-[#e5e7eb] bg-white px-6 py-3.5 text-sm font-medium text-[#333333] hover:border-[#04b0ba] hover:-translate-y-0.5 transition-all"
        >
          <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            <path fill="none" d="M0 0h48v48H0z"/>
          </svg>
          Continuar con Google
        </button>

        <p className="mt-6 text-[11px] text-center text-[#666666]">
          Al iniciar sesión aceptas las políticas de acceso.
        </p>
      </div>
    </div>
  );
}
